/* B04: per-product media. Views never change the purchase variant or cart. */
(function () {
  'use strict';
  var TRUSTED = ['cdn.shopify.com', 'ray-ban.com', 'oakley.com', 'luxottica.com', 'essilorluxottica.com', 'sunglasshut.com', 'vogue-eyewear.com'];
  function safeURL(value, base) {
    try {
      base = base || (typeof document !== 'undefined' ? document.baseURI : undefined);
      var u = new URL(value, base);
      var nativeStoreImage = base && u.origin === new URL(base).origin && /^\/cdn\/shop\/(?:files|products)\//.test(u.pathname);
      return u.protocol === 'https:' && (nativeStoreImage || TRUSTED.some(function (h) { return u.hostname === h || u.hostname.endsWith('.' + h); })) ? u.href : '';
    } catch (_) { return ''; }
  }
  function themeAssetURL(name, base, pageURL) {
    if (!/^[a-z0-9][a-z0-9._-]*$/i.test(name || '') || !base) return '';
    try {
      // asset_url may use the storefront's protocol-relative CDN path.
      // Trust only the theme asset directory, not arbitrary storefront media.
      var page = new URL(pageURL), source = new URL(base, page);
      var storefrontAsset = source.origin === page.origin && /^\/cdn\/shop\/t\/\d+\/assets\//.test(source.pathname);
      var shopifyAsset = source.hostname === 'cdn.shopify.com' && /^\/s\/files\/(?:\d+\/)+t\/\d+\/assets\//.test(source.pathname);
      if (source.protocol !== 'https:' || (!storefrontAsset && !shopifyAsset)) return '';
      return new URL(name, source).href;
    } catch (_) { return ''; }
  }
  function scaled(value, width) {
    var src = safeURL(value);
    if (!src) return '';
    var u = new URL(src);
    if ((u.hostname === 'cdn.shopify.com' || /^\/cdn\/shop\/(?:files|products)\//.test(u.pathname)) && u.pathname.indexOf('/3d/') < 0) u.searchParams.set('width', String(width));
    return u.href;
  }
  function responsive(value) {
    var u = new URL(value);
    return u.hostname === 'cdn.shopify.com' || /^\/cdn\/shop\/(?:files|products)\//.test(u.pathname);
  }
  function completeSpin(spin) {
    if (!spin || !Array.isArray(spin.frames) || spin.frames.length !== 12) return false;
    return spin.frames.every(function (src, i) {
      var m = String(src).match(/_(\d{3})A(?:\.|_[0-9a-f]{8}-)/i);
      return safeURL(src) && m && Number(m[1]) === i * 30;
    });
  }
  function indices(values, media) {
    return Array.isArray(values) ? values.filter(function (i, n, all) { return Number.isInteger(i) && media[i] && safeURL(media[i].url) && all.indexOf(i) === n; }) : [];
  }
  function confirmedIncluded(row, media) {
    // A photographed identity is not a promise that every pictured accessory
    // ships with the purchase. Legacy labels never count as confirmation.
    return row && row.included_fulfillment_confirmed === true ? indices(row.included, media) : [];
  }
  function capabilityKey(variantId, experience) { return String(variantId) + ':' + experience; }
  function experienceAllowed(row, key, failed) {
    return !!(row && row[key] && row[key].availability !== 'HOLD' && !failed.has(capabilityKey(row.id,key)));
  }
  function metaVariantKey(row) {
    var sku = String(row.sku || '').toUpperCase().match(/^0?(RW\d+)\s+(\S+)/);
    if (!sku) return null;
    var color = sku[2].replace(/[^A-Z0-9]/g, '');
    var size = (row.options || []).join(' ').match(/\b(\d{2})\s*mm\b/i);
    // Some native SKUs append the lens size to the colour code.
    if (size && color.length > 6 && color.endsWith(size[1])) color = color.slice(0, -size[1].length);
    return {model:sku[1], color:color};
  }
  function metaMediaKey(media) {
    var name;
    try { name = decodeURIComponent(new URL(media.url).pathname.split('/').pop()); } catch (_) { return null; }
    var legacy = name.match(/^ray-ban-meta-(skyler|wayfarer|headliner)-([a-z0-9-]+)-(quarter|front|lateral|back)\./i);
    var official = name.match(/^0?(RW\d+)__([a-z0-9_]+)__(?:P21|STD)__shad__(qt|al2|al31|fr|al4|lt|bk|cfr|al3)(?:[_.-])/i);
    var model, color, view;
    if (legacy) {
      model = {skyler:'RW4014',wayfarer:'RW4012',headliner:'RW4013'}[legacy[1].toLowerCase()];
      color = legacy[2]; view = {quarter:'qt',front:'fr',lateral:'lt',back:'bk'}[legacy[3].toLowerCase()];
    } else if (official) { model = official[1].toUpperCase(); color = official[2]; view = official[3].toLowerCase(); }
    else return null;
    var labels = {qt:'Tres cuartos',al2:'Tres cuartos interior',fr:'Frontal',lt:'Lateral',bk:'Posterior',cfr:'Detalle interior',al31:'Transitions activados · tres cuartos',al4:'Transitions activados · frontal',al3:'Transitions activados · superior'};
    return {model:model,color:color.toUpperCase().replace(/[^A-Z0-9]/g,''),view:view,label:labels[view],rank:['qt','al2','fr','lt','bk','cfr','al31','al4','al3'].indexOf(view)};
  }
  function buildMetaManifest(native) {
    if (!native || !native.product || !Array.isArray(native.media) || !Array.isArray(native.variants)) throw new Error('native-meta');
    var nativeMedia = native.media.map(function (m) { return Object.assign({},m,{url:safeURL(m.url)}); });
    var data = {schema:1,product:native.product,media:[],variants:{},nativeMeta:true};
    native.variants.forEach(function (variant) {
      var key = metaVariantKey(variant);
      var matches = nativeMedia.map(function (media) { return {media:media,key:metaMediaKey(media)}; }).filter(function (entry) {
        return key && entry.key && entry.key.model === key.model && entry.key.color === key.color && safeURL(entry.media.url);
      });
      matches.sort(function (a,b) {
        return (String(b.media.id) === variant.featuredMediaId) - (String(a.media.id) === variant.featuredMediaId) || a.key.rank - b.key.rank;
      });
      // A new upload with an arbitrary filename can still use its own native
      // variant image. Never borrow a recognised image from another colour.
      if (!matches.length) {
        var own = nativeMedia.find(function (m) { return String(m.id) === variant.featuredMediaId && !metaMediaKey(m) && safeURL(m.url); });
        if (own) matches.push({media:own,key:{view:'other',label:'Vista'}});
      }
      var images = matches.map(function (entry) {
        var index = data.media.length;
        data.media.push(Object.assign({},entry.media,{kind:'images',scope:'variant',view:entry.key.view,label:entry.key.label,source:'native-meta'}));
        return index;
      });
      data.variants[String(variant.id)] = Object.assign({},variant,{key:key ? key.model+'_'+key.color : '',images:images,worn:[],included:[],spin:null,model3d:null,tryon:null});
    });
    return data;
  }
  function catalogCode(value) { return String(value || '').toUpperCase().replace(/[^A-Z0-9]/g,'').replace(/^0(?=[A-Z])/,''); }
  function catalogVariantKey(row) {
    var match = String(row.sku || '').toUpperCase().match(/^(0?[A-Z]{2,4}[0-9][A-Z0-9-]*)\s+(\S+)/);
    return match ? {model:catalogCode(match[1]),color:catalogCode(match[2])} : null;
  }
  function catalogMediaKey(src) {
    var name;
    try { name = decodeURIComponent(new URL(src).pathname.split('/').pop()).toUpperCase(); } catch (_) { return null; }
    var match = name.match(/^(0?[A-Z]{2,4}[0-9][A-Z0-9-]*)__([A-Z0-9_]+?)(?:__(?:P\d+|STD|[0-9]{3}A)|_[0-9]{3}A|\.(?:PNG|AVIF|WEBP|JPE?G))/);
    return match ? {model:catalogCode(match[1]),color:catalogCode(match[2])} : null;
  }
  function catalogAssetKey(src) {
    try {
      var u = new URL(src), match = u.pathname.match(/\/(files|products)\/([^/]+)$/);
      var ownShopifyFile = u.hostname === 'cdn.shopify.com' && /^\/s\/files\/1\/0734\/6366\/0839\//.test(u.pathname);
      return match && (ownShopifyFile || /^\/cdn\/shop\//.test(u.pathname)) ? 'shopify:'+match[1]+'/'+match[2] : u.origin+u.pathname;
    } catch (_) { return ''; }
  }
  function catalogView(src) {
    var match = String(src).match(/__shad__(qt|fr|al1|al2|al3|al4|al31|lt|bk|cfr|cqt|cpr)(?:[_.-])/i);
    var frame = String(src).match(/_(000|030|090|180)A(?:\.|_)/i);
    var view = match ? match[1].toLowerCase() : frame ? {'000':'fr','030':'qt','090':'lt','180':'bk'}[frame[1]] : 'other';
    return {view:view,label:{qt:'Tres cuartos',fr:'Frontal',al1:'Vista alternativa',al2:'Vista alternativa',al3:'Vista superior',al4:'Vista alternativa frontal',al31:'Vista alternativa',lt:'Lateral',bk:'Posterior',cfr:'Detalle interior',cqt:'Detalle',cpr:'Detalle'}[view] || 'Vista'};
  }
  function catalogCompatible(actual, expected) { return !actual || !expected || (actual.model === expected.model && actual.color === expected.color); }
  function buildCatalogManifest(native, curated) {
    if (!native || !native.product || !Array.isArray(native.media) || !Array.isArray(native.variants)) throw new Error('native-catalog');
    if (String(native.product.handle).indexOf('ray-ban-meta-') === 0) return buildMetaManifest(native);
    if (!curated || curated.schema !== 1 || !curated.product || String(curated.product.id) !== String(native.product.id)) curated = {media:[],variants:{}};
    var data = {schema:1,product:native.product,media:(curated.media || []).slice(),variants:{},nativeCatalog:true,unavailable:curated.unavailable || []};
    var blocked = new Set(data.unavailable.map(catalogAssetKey));
    var nativeMedia = native.media.map(function (m) { return Object.assign({},m,{url:safeURL(m.url)}); });
    function usable(media) { return media && safeURL(media.url) && !blocked.has(catalogAssetKey(media.url)); }
    native.variants.forEach(function (variant) {
      var old = curated.variants && curated.variants[String(variant.id)];
      var row = Object.assign({images:[],worn:[],included:[],spin:null,model3d:null,tryon:null},old || {},variant);
      var expected = catalogVariantKey(variant);
      // A documented manufacturer identity can disambiguate conflicting sale
      // metadata without changing the native purchase variant or stock codes.
      if (old && old.verifiedIdentity && String(old.verifiedIdentity.gtin) === String(variant.gtin)) {
        var verified = String(old.verifiedIdentity.key || '').split('_');
        if (verified.length === 2) expected = {model:catalogCode(verified[0]),color:catalogCode(verified[1])};
      }
      if (!expected && old && old.key) {
        var split = old.key.indexOf('_');
        if (split > 0) expected = {model:catalogCode(old.key.slice(0,split)),color:catalogCode(old.key.slice(split+1))};
      }
      var seen = new Set(), views = new Set();
      row.images = (old && old.images || []).filter(function (ix) {
        var media = data.media[ix], key = media && catalogAssetKey(media.url);
        if (!usable(media) || !catalogCompatible(catalogMediaKey(media.url),expected) || seen.has(key)) return false;
        seen.add(key);var view=catalogView(media.url).view;if(view !== 'other')views.add(view);return true;
      });
      nativeMedia.forEach(function (media) {
        if (!usable(media) || !expected) return;
        var actual = catalogMediaKey(media.url), compact = false;
        if (!actual) {
          var name = decodeURIComponent(new URL(media.url).pathname.split('/').pop()).toUpperCase();
          var prefix = '0'+expected.model+expected.color;
          compact = name.indexOf(prefix) === 0 && /^[_.-]/.test(name.slice(prefix.length));
        }
        if ((!actual || !catalogCompatible(actual,expected)) && !compact) return;
        var view = catalogView(media.url), key = catalogAssetKey(media.url);
        if (seen.has(key) || (view.view !== 'other' && views.has(view.view))) return;
        if (view.view === 'qt' && row.images.some(function (ix) { var prior=data.media[ix];return catalogView(prior.url).view === 'other' && catalogMediaKey(prior.url) && catalogCompatible(catalogMediaKey(prior.url),expected); })) return;
        if (view.view === 'other' && row.images.length && !compact) return;
        // Existing 360° sequences stay in their own viewer.
        if (/_\d{3}A(?:\.|_)/i.test(media.url) && row.images.length) return;
        seen.add(key);if(view.view !== 'other')views.add(view.view);
        row.images.push(data.media.length);
        data.media.push(Object.assign({},media,{kind:'images',scope:'variant',source:'native-catalog',view:view.view,label:view.label}));
      });
      if (!row.images.length) {
        var own = nativeMedia.find(function (m) { return String(m.id) === variant.featuredMediaId && usable(m) && catalogCompatible(catalogMediaKey(m.url),expected); });
        if (own) { row.images.push(data.media.length);data.media.push(Object.assign({},own,{kind:'images',scope:'variant',view:'other',label:'Vista',source:'native-variant'})); }
      }
      ['worn','included'].forEach(function (group) { row[group] = (old && old[group] || []).filter(function (ix) { return usable(data.media[ix]) && catalogCompatible(catalogMediaKey(data.media[ix].url),expected); }); });
      if (row.tryon && (!usable(data.media[row.tryon.image]) || !catalogCompatible(catalogMediaKey(data.media[row.tryon.image].url),expected))) {
        var front = row.images.find(function (ix) { return catalogView(data.media[ix].url).view === 'fr'; });
        row.tryon = front === undefined ? null : Object.assign({},row.tryon,{image:front});
      }
      if (row.model3d && row.model3d.gtin && String(row.model3d.gtin) !== String(variant.gtin)) row.model3d = null;
      if (row.spin && Array.isArray(row.spin.frames) && row.spin.frames.some(function (url) { return blocked.has(catalogAssetKey(url)) || !catalogCompatible(catalogMediaKey(url),expected); })) row.spin = null;
      row.key = expected ? expected.model+'_'+expected.color : old && old.key || '';
      data.variants[String(variant.id)] = row;
    });
    return data;
  }
  if (typeof module !== 'undefined' && module.exports) module.exports = {safeURL: safeURL, themeAssetURL: themeAssetURL, scaled: scaled, completeSpin: completeSpin, indices: indices, confirmedIncluded: confirmedIncluded, capabilityKey: capabilityKey, experienceAllowed: experienceAllowed, metaVariantKey:metaVariantKey, metaMediaKey:metaMediaKey, buildMetaManifest:buildMetaManifest, catalogVariantKey:catalogVariantKey,catalogMediaKey:catalogMediaKey,catalogAssetKey:catalogAssetKey,buildCatalogManifest:buildCatalogManifest};
  if (typeof document === 'undefined') return;
  if (window.RevalB04Media) return;
  var manifests = new Map(), scripts = new Map(), instances = new WeakMap();
  function element(tag, className, text) {
    var el = document.createElement(tag);
    if (className) el.className = className;
    if (text !== undefined) el.textContent = text;
    return el;
  }
  function button(text, handler) {
    var el = element('button', '', text); el.type = 'button';
    el.addEventListener('click', handler); return el;
  }
  function script(src) {
    if (!src) return Promise.reject(new Error('resource-url'));
    if (!scripts.has(src)) scripts.set(src, new Promise(function (resolve, reject) {
      var el = document.createElement('script'); el.src = src; el.async = true; el.crossOrigin = 'anonymous';
      if (src.indexOf('@google/model-viewer@') >= 0) el.type = 'module';
      el.onload = resolve;
      el.onerror = function () { scripts.delete(src); el.remove(); reject(new Error('resource')); };
      document.head.appendChild(el);
    }));
    return scripts.get(src);
  }
  function manifest(src) {
    if (!manifests.has(src)) manifests.set(src, fetch(src, {credentials: 'omit'}).then(function (res) {
      if (!res.ok) throw new Error('manifest'); return res.json();
    }).catch(function (e) { manifests.delete(src); throw e; }));
    return manifests.get(src);
  }
  function loadImage(src) {
    return new Promise(function (resolve, reject) {
      var im = new Image(); im.onload = function () { resolve(im); }; im.onerror = reject; im.src = src;
    });
  }
  function displayVariantTitle(id, title) {
    return String(id) === '51373531726119' ? String(title).replace(/35\s?mm/g, 'Talla L') : title;
  }
  function Gallery(root) {
    this.root = root; this.data = null; this.row = null; this.group = 'images'; this.position = 0;
    this.generation = 0; this.dialogGeneration = 0; this.failed = new Set(); this.opener = null;
    this.failedExperiences = new Set();
    this.hero = root.querySelector('[data-b04-hero]'); this.zoom = root.querySelector('[data-b04-zoom]');
    this.empty = root.querySelector('[data-b04-empty]'); this.status = root.querySelector('[data-b04-status]');
    this.dialog = root.querySelector('[data-b04-dialog]'); this.content = root.querySelector('[data-b04-dialog-content]');
    this.dialogTitle = root.querySelector('[data-b04-dialog-title]'); this.note = root.querySelector('[data-b04-dialog-note]');
    this.caption = root.querySelector('[data-b04-caption]'); this.views = root.querySelector('[data-b04-views]');
    this.counter = root.querySelector('[data-b04-counter]'); this.category = root.querySelector('[data-b04-categories]');
    var self = this;
    this.zoom.addEventListener('click', function () { self.openPhoto(); });
    root.querySelector('[data-b04-close]').addEventListener('click', function () { self.dialog.close(); });
    this.dialog.addEventListener('close', function () {
      self.dialogGeneration++;
      if (window.RevalB04Tryon) window.RevalB04Tryon.close();
      self.content.replaceChildren(); self.note.textContent = '';
      if (self.dialogMode === 'photo' && self.row && self.list().length) self.select(self.position);
      if (self.opener && self.opener.isConnected) self.opener.focus();
    });
    this.dialog.addEventListener('click', function (e) { if (e.target === self.dialog) {
      var r = self.dialog.getBoundingClientRect();
      if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) self.dialog.close();
    }});
    this.dialog.addEventListener('keydown', function (e) {
      if (!self.dialog.open || self.dialogMode !== 'photo' || /INPUT|BUTTON|A/.test(e.target.tagName)) return;
      if (e.key === 'ArrowLeft' || e.key === 'ArrowRight') { e.preventDefault(); self.zoomPhoto(e.key === 'ArrowRight' ? 1 : -1); }
    });
    root.querySelectorAll('[data-b04-experience]').forEach(function (el) {
      el.addEventListener('click', function () { self.openExperience(el.dataset.b04Experience, el); });
    });
    var nativeMeta = root.querySelector('[data-b04-native-meta]');
    var nativeCatalog = root.querySelector('[data-b04-native-catalog]');
    var source = nativeCatalog ? manifest(root.dataset.b04Manifest).catch(function () { return null; }).then(function (data) { return buildCatalogManifest(JSON.parse(nativeCatalog.textContent),data); }) : nativeMeta ? Promise.resolve().then(function () { return buildMetaManifest(JSON.parse(nativeMeta.textContent)); }) : manifest(root.dataset.b04Manifest);
    source.then(function (data) {
      if (!data || data.schema !== 1 || String(data.product.id) !== root.dataset.b04Product || !Array.isArray(data.media)) throw new Error('identity');
      self.data = data; self.setVariant(root.dataset.b04Variant, true);
    }).catch(function () {
      self.status.textContent = 'Las vistas adicionales no están disponibles en este momento.';
      // A working native hero remains zoomable; this never disables purchase.
    });
  }
  Gallery.prototype.asset = function (name) {
    return themeAssetURL(name, this.root.dataset.b04AssetBase, document.baseURI);
  };
  Gallery.prototype.list = function () { return this.row ? this.row[this.group].filter(function (i) { return !this.failed.has(i); }, this) : []; };
  Gallery.prototype.media = function () { var list = this.list(); return this.data && this.data.media[list[this.position]]; };
  Gallery.prototype.setVariant = function (id, initial) {
    this.generation++; this.dialogGeneration++;
    if (this.dialog.open) { this.dialogMode = null; this.dialog.close(); }
    // A synchronous close handler must not resume the previous photo request.
    this.generation++;
    this.failed.clear(); this.group = 'images'; this.position = 0; this.root.dataset.b04Variant = String(id);
    this.zoom.removeAttribute('aria-busy');
    if (!initial) { this.zoom.hidden = true; this.hero.removeAttribute('src'); this.hero.removeAttribute('srcset'); }
    var row = this.data && this.data.variants[String(id)];
    if (!row) {
      if (!initial) { this.hero.removeAttribute('src'); this.hero.removeAttribute('srcset'); this.zoom.hidden = true; this.empty.hidden = false; }
      this.root.querySelector('[data-b04-tools]').hidden = true; this.views.hidden = true;
      this.root.querySelector('[data-b04-experiences]').hidden = true; this.row = null;
      return;
    }
    this.row = Object.assign({}, row);
    this.displayTitle = displayVariantTitle(id, row.title);
    this.root.dataset.b04Title = this.data.product.title + ' · ' + this.displayTitle;
    this.zoom.setAttribute('aria-label', 'Ampliar imagen de ' + this.displayTitle);
    this.hero.alt = this.root.dataset.b04Title;
    ['images','worn','included'].forEach(function (key) { this.row[key] = indices(row[key], this.data.media); }, this);
    this.row.included = confirmedIncluded(row, this.data.media);
    this.category.replaceChildren();
    var self = this;
    [['images','Vistas'],['worn','Puestos'],['included','Lo que recibes']].forEach(function (entry) {
      if (!self.row[entry[0]].length) return;
      var el = button(entry[1], function () { self.group = entry[0]; self.position = 0; self.renderViews(); self.select(0); });
      el.dataset.b04Group = entry[0]; self.category.appendChild(el);
    });
    this.root.querySelectorAll('[data-b04-experience]').forEach(function (el) {
      var key = el.dataset.b04Experience, value = row[key];
      var ready = key === 'spin' ? completeSpin(value) : key === 'model3d' ? value && (self.asset(value.asset) || safeURL(value.url)) : value && self.data.media[value.image] && safeURL(self.data.media[value.image].url);
      el.hidden = !ready || !experienceAllowed(row,key,self.failedExperiences); el.disabled = false;
    });
    this.updateExperiences(); this.renderViews();
    if (!this.row.images.length) { this.zoom.hidden = true; this.empty.hidden = false; this.hero.removeAttribute('src'); this.hero.removeAttribute('srcset'); }
    else if (!initial || this.data.nativeMeta || this.data.nativeCatalog || !this.hero.getAttribute('src')) this.select(0);
    else { this.empty.hidden = true; this.zoom.hidden = false; this.updateLabels(); }
  };
  Gallery.prototype.updateExperiences = function () {
    this.root.querySelector('[data-b04-experiences]').hidden = !Array.from(this.root.querySelectorAll('[data-b04-experience]')).some(function (el) { return !el.hidden; });
  };
  Gallery.prototype.renderViews = function () {
    var self = this, list = this.list(); this.views.replaceChildren();
    list.forEach(function (ix, n) {
      var media = self.data.media[ix], label = self.group === 'images' ? media.label : 'Foto ' + (n + 1);
      var el = button('', function () { self.select(n); });
      el.setAttribute('aria-label', 'Ver ' + label.toLowerCase() + ', ' + (n + 1) + ' de ' + list.length);
      if (responsive(media.url)) {
        var thumb = element('img'); thumb.src = scaled(media.url, 160); thumb.alt = ''; thumb.width = 80; thumb.height = 44; thumb.loading = 'lazy'; thumb.decoding = 'async';
        thumb.addEventListener('error', function () { thumb.remove(); }); el.appendChild(thumb);
      }
      el.appendChild(element('span', '', label)); self.views.appendChild(el);
    });
    this.views.hidden = list.length < 2;
    this.root.querySelector('[data-b04-tools]').hidden = !this.row || !(this.row.images.length + this.row.worn.length + this.row.included.length);
    this.updateLabels();
  };
  Gallery.prototype.updateLabels = function () {
    var media = this.media(), list = this.list(); this.counter.textContent = list.length ? (this.position + 1) + ' / ' + list.length : '';
    Array.from(this.views.children).forEach(function (el, i) { el.setAttribute('aria-pressed', String(i === this.position)); }, this);
    Array.from(this.category.children).forEach(function (el) { el.setAttribute('aria-pressed', String(el.dataset.b04Group === this.group)); }, this);
    this.caption.textContent = !media ? '' : this.group === 'worn' ? 'Fotografía real del modelo y color. La talla fotografiada puede variar.' : this.group === 'included' ? 'Fotografía del contenido identificado para esta variante.' : '';
  };
  Gallery.prototype.select = function (position) {
    var self = this, generation = ++this.generation, list = this.list();
    if (!list.length) return;
    var displayWidth = this.zoom.clientWidth || this.root.clientWidth || 800;
    var media = this.data.media[list[position]], request = scaled(media.url, Math.max(500, Math.min(1600, Math.ceil(displayWidth * (window.devicePixelRatio || 1)))));
    this.zoom.setAttribute('aria-busy', 'true');
    this.status.textContent = '';
    loadImage(request).then(function () {
      if (generation !== self.generation) return;
      self.position = position; self.hero.removeAttribute('srcset'); self.hero.removeAttribute('sizes');
      if (responsive(media.url)) {
        self.hero.srcset = [500,800,1200,1600].map(function (w) { return scaled(media.url,w)+' '+w+'w'; }).join(',');
        self.hero.sizes = '(max-width: 600px) 90vw, 52vw';
      }
      self.hero.src = request; self.hero.alt = self.data.product.title + ' · ' + self.displayTitle + ' · ' + media.label;
      self.hero.classList.toggle('b04-hero-worn', self.group === 'worn');
      self.zoom.hidden = false; self.empty.hidden = true; self.status.textContent = ''; self.updateLabels();
    }).catch(function () {
      if (generation !== self.generation) return;
      self.failed.add(list[position]); self.position = 0; self.renderViews();
      if (self.list().length) self.select(0);
      else {
        self.hero.removeAttribute('src'); self.hero.removeAttribute('srcset'); self.zoom.hidden = true; self.empty.hidden = false;
        self.status.textContent = 'Las imágenes de esta variante no están disponibles en este momento.';
      }
    }).finally(function () { if (generation === self.generation) self.zoom.removeAttribute('aria-busy'); });
  };
  Gallery.prototype.open = function (title, trigger, mode) {
    if (typeof this.dialog.showModal !== 'function') { this.status.textContent = 'Esta experiencia no está disponible en este navegador.'; return false; }
    this.dialogGeneration++; this.content.replaceChildren(); this.note.textContent = '';
    this.dialogTitle.textContent = title; this.opener = trigger || document.activeElement; this.dialogMode = mode;
    this.dialog.showModal(); return true;
  };
  Gallery.prototype.openPhoto = function () {
    if (!this.open('Imagen ampliada',this.zoom,'photo')) return;
    this.zoomPhoto(0);
  };
  Gallery.prototype.zoomPhoto = function (step) {
    var self = this, list = this.list();
    if (list.length) this.position = (this.position + step + list.length) % list.length;
    var media = this.media(), src = media ? safeURL(media.url) : safeURL(this.hero.currentSrc || this.hero.src);
    this.content.replaceChildren(); if (!src) return;
    var image = element('img','b04-enlarged'); image.src = src; image.alt = media ? this.data.product.title + ' · ' + this.displayTitle + ' · ' + media.label : this.hero.alt;
    image.addEventListener('error',function () { self.note.textContent = 'No se pudo cargar esta imagen ampliada.'; });
    this.content.appendChild(image);
    if (list.length > 1) {
      var nav = element('div','b04-dialog-nav'); nav.appendChild(button('Anterior',function () { self.zoomPhoto(-1); }));
      nav.appendChild(element('span','',(this.position+1)+' / '+list.length));
      nav.appendChild(button('Siguiente',function () { self.zoomPhoto(1); })); this.content.appendChild(nav);
    }
    var link = element('a','b04-original','Abrir imagen a tamaño completo'); link.href = src; link.target = '_blank'; link.rel = 'noopener'; this.content.appendChild(link);
    this.note.textContent = this.group === 'worn' ? 'Referencia del modelo y color; no certifica la talla o el ajuste.' : '';
  };
  Gallery.prototype.failExperience = function (key, generation) {
    if (generation !== this.dialogGeneration) return;
    this.failedExperiences.add(capabilityKey(this.root.dataset.b04Variant,key));
    var el = this.root.querySelector('[data-b04-experience="'+key+'"]'); if (el) el.hidden = true;
    this.updateExperiences(); this.content.replaceChildren();
    this.note.textContent = 'Esta experiencia no está disponible en este momento. Las fotografías y la compra siguen disponibles.';
  };
  Gallery.prototype.openExperience = function (key, trigger) {
    if (!experienceAllowed(this.row,key,this.failedExperiences)) return;
    var titles = {spin:'Vista 360°',model3d:'Vista 3D',tryon:'Probador visual'};
    if (!this.open(titles[key],trigger,key)) return;
    var self = this, generation = this.dialogGeneration, value = this.row[key];
    if (key === 'spin') {
      if (!completeSpin(value)) return this.failExperience(key,generation);
      var im = element('img','b04-enlarged'); im.alt = this.data.product.title + ' · ' + this.displayTitle + ' · Vista 360°';
      var range = element('input'); range.type = 'range'; range.min = 0; range.max = 11; range.step = 1; range.value = 0; range.setAttribute('aria-label','Ángulo de la vista 360 grados');
      var ready = [], position = 0, output = element('span','','0°'); range.disabled = true;
      function angle(n) { position = (n+12)%12; range.value = position; output.textContent = (position*30)+'°'; im.src = ready[position].src; }
      var nav = element('div','b04-dialog-nav');
      var prev = button('Girar a la izquierda',function () { angle(position-1); }), next = button('Girar a la derecha',function () { angle(position+1); }); prev.disabled = next.disabled = true;
      nav.append(prev,output,next); this.content.append(im,range,nav);
      this.note.textContent = 'Cargando la secuencia completa…';
      // Twelve existing photographs, never a generated/simulated rotation.
      var nextIndex = 0;
      function worker() {
        if (generation !== self.dialogGeneration || nextIndex >= 12) return Promise.resolve();
        var index = nextIndex++;
        return loadImage(scaled(value.frames[index],1200)).then(function (frame) { ready[index] = frame; return worker(); });
      }
      Promise.all([worker(),worker(),worker()]).then(function () {
        if (generation !== self.dialogGeneration) return;
        if (ready.filter(Boolean).length !== 12) throw new Error('sequence');
        range.disabled = false; prev.disabled = next.disabled = false; angle(0);
        self.note.textContent = '12 fotografías del modelo y color. Arrastra el control o usa las flechas; no mide el ajuste.';
      }).catch(function () { self.failExperience(key,generation); });
      range.addEventListener('input',function () { if (ready.length === 12) angle(Number(range.value)); });
    } else if (key === 'model3d') {
      var src = this.asset(value.asset) || safeURL(value.url); if (!src) return this.failExperience(key,generation);
      this.note.textContent = 'Cargando vista 3D…';
      var loaded = customElements.get('model-viewer') ? Promise.resolve() : script('https://cdn.jsdelivr.net/npm/@google/model-viewer@3.5.0/dist/model-viewer.min.js');
      loaded.then(function () {
        if (generation !== self.dialogGeneration || !self.dialog.open) return;
        var viewer = element('model-viewer','b04-model'); viewer.setAttribute('src',src); viewer.setAttribute('camera-controls',''); viewer.setAttribute('interaction-prompt','none'); viewer.setAttribute('touch-action','pan-y'); viewer.setAttribute('alt',self.data.product.title+' · '+self.displayTitle);
        viewer.addEventListener('error',function () { self.failExperience(key,generation); });
        viewer.addEventListener('load',function () { if (generation === self.dialogGeneration) self.note.textContent = 'Gira y amplía con el dedo o el ratón. Referencia visual; no determina el ajuste de la talla seleccionada.'; });
        self.content.appendChild(viewer);
      }).catch(function () { self.failExperience(key,generation); });
    } else if (key === 'tryon') {
      var p = element('p','b04-tryon-intro','Una aproximación visual con la cámara; no determina talla ni ajuste. El procesamiento de la imagen ocurre en este navegador. Se cargarán las bibliotecas existentes de MediaPipe desde jsDelivr. Este componente no guarda ni sube fotografías.');
      var start = button('Continuar y permitir cámara',function () {
        start.disabled = true; self.note.textContent = 'Preparando el probador…';
        var loaded = window.RevalB04Tryon ? Promise.resolve() : script(self.asset('reval-b04-media-tryon.js'));
        loaded.then(function () {
          if (generation !== self.dialogGeneration || !self.dialog.open) return;
          if (!window.RevalB04Tryon || typeof window.RevalB04Tryon.open !== 'function') throw new Error('tryon-module');
          var media = self.data.media[value.image];
          window.RevalB04Tryon.open({host:self.content,imageUrl:safeURL(media.url),mode:value.mode,productTitle:self.data.product.title+' · '+self.displayTitle,isCurrent:function () { return generation === self.dialogGeneration && self.dialog.open; }});
          self.note.textContent = 'Cierra esta ventana para detener la cámara. Esta visualización no certifica ajuste ni medidas.';
        }).catch(function () { self.failExperience(key,generation); });
      }); this.content.append(p,start);
    }
  };
  function init(scope) {
    (scope || document).querySelectorAll('[data-b04-gallery]').forEach(function (root) {
      if (!instances.has(root)) instances.set(root,new Gallery(root));
    });
  }
  window.RevalB04Media = {init:init,setVariant:function (id,scope) { (scope || document).querySelectorAll('[data-b04-gallery]').forEach(function (root) { var g = instances.get(root); if (g) g.setVariant(id,false); }); }};
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',function () { init(); }); else init();
  window.addEventListener('pageshow',function () { init(); });
  document.addEventListener('shopify:section:load',function (e) { init(e.target); });
  document.addEventListener('reval:variant:changed',function (e) { if (e.detail && e.detail.variantId) window.RevalB04Media.setVariant(String(e.detail.variantId)); });
  window.addEventListener('pagehide',function () { if (window.RevalB04Tryon) window.RevalB04Tryon.close(); });
})();
